/**
 * @generated SignedSource<<879e260999bb55be4ba62225b19d4bec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "phoneNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lang",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NeedCoverModalQuery",
    "selections": (v0/*: any*/),
    "type": "ClientAppQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "NeedCoverModalQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "09b544fd4a81a8c564fd6b3397c68eb5",
    "id": null,
    "metadata": {},
    "name": "NeedCoverModalQuery",
    "operationKind": "query",
    "text": "query NeedCoverModalQuery {\n  user {\n    id\n    firstName\n    lastName\n    phoneNumber\n    lang\n  }\n}\n"
  }
};
})();

node.hash = "137219118be26ca318d6b92e3d913545";

module.exports = node;
